/**
 * @author Madhu.Sudhan
 * @Date: 2022-11-21 14:49:54
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2022-11-23 10:49:54
 */

import { bool, func, shape, string } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { getUpdatedUserProfile, resetPopup } from '../HeaderContainer/actions';
import { selectHeaderContainerJS } from '../HeaderContainer/selectors';
import { SetFundTransfer, SetNsdlFundTransfer, getOtp, yblDeleteBeneficiary, yblVerifyLimitOtp } from '../NetworkCards/actions';
import { GET_OTP_SUCCESS, NETWORKCARD_CONSTANTS, SET_CHANNEL_FLAG_SUCCESS, YBL_DELETE_BENEFICIARY_SUCCESS } from '../NetworkCards/constants';
import { get_yes_bank_otp, select_cardBlockJS, select_isBoolean, set_channel_flag } from '../NetworkCards/selectors';

/**
 * @class NsdlFundTransfer
 */


const NsdlFundTransferPropTypes = {
  isLoadingStatus: bool.isRequired,
  type: string.isRequired,
  form: shape({}).isRequired,
  NsdlFundTransfer: shape({}).isRequired,
  otherParams: shape({}).isRequired,
  handleModal: func.isRequired,
};

/**
 * @class FundTransfer
 */

const FundTransferPropTypes = {
  isLoadingStatus: bool.isRequired,
  BeneficiariesList: shape({}).isRequired,
  history: shape({}).isRequired,
  form: shape({}).isRequired,
  BeneficiaryView: shape({}).isRequired,
  SelectUserDetails: shape({}).isRequired,
  NsdlFundTransfer: shape({}).isRequired,
  NsdlFundTransferlist: shape({}).isRequired,
  BeneficiaryUpdate: shape({}).isRequired,
  BeneficiaryCreate: shape({}).isRequired,
  YblVerifyLimitOtpSuccess: shape({}).isRequired,
  YblDeleteBeneficiarySuccess: shape({}).isRequired,
  GetYesBankOtpSuccess: shape({}).isRequired,
  SetChannelFlagSuccess: shape({}).isRequired,
  onInitFundTransfer: func.isRequired,
  onSetFundTransfer: func.isRequired,
  onInitUpdatedUserProfile: func.isRequired,
  onInitNsdlFundTransfer: func.isRequired,
  onSetNsdlFundTransfer: func.isRequired,
  onYblVerifyLimitOtp: func.isRequired,
  onResetPopup: func.isRequired,
  onSetYblVerifyLimitOtp: func.isRequired,
  onInitYblDeleteBeneficiary: func.isRequired,
  onSetYblDeleteBeneficiarySuccess: func.isRequired,
  onGetOtp: func.isRequired,
  onSetChannelFlagSuccess: func.isRequired,
  onGetOtpSuccess: func.isRequired,
};

const OtpScreenPropTypes = {
  handleOTPChange: shape({}).isRequired,
  isLoadingStatus: shape({}).isRequired,
  remainingTime: shape({}).isRequired,
  handleResendOtpForFundTransfer: func.isRequired,
  verifyOTP: func.isRequired,
};

const FundTransferMapDispatchToProps = (dispatch) => ({
  onInitFundTransfer: (payload, otherParams) => dispatch(SetFundTransfer(payload, otherParams)),
  onSetFundTransfer: () => dispatch({ type: NETWORKCARD_CONSTANTS.SET_BENEFICIARY_VIEW, payload: { status: false } }),
  onInitUpdatedUserProfile: () => dispatch(getUpdatedUserProfile()),
  onInitNsdlFundTransfer: (payload, otherParams) => dispatch(SetNsdlFundTransfer(payload, otherParams)),
  onSetNsdlFundTransfer: () => dispatch({ type: NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARY_VIEW, payload: { status: false } }),
  onYblVerifyLimitOtp: (payload) => dispatch(yblVerifyLimitOtp(payload)),
  onResetPopup: (payload, actionType, alertType) => dispatch(resetPopup(payload, actionType, alertType)),
  onSetYblVerifyLimitOtp: () => dispatch({ type: NETWORKCARD_CONSTANTS.SET_YBL_VERIFY_LIMIT_OTP, payload: { status: false } }),
  onInitYblDeleteBeneficiary: (payload) => dispatch(yblDeleteBeneficiary(payload)),
  onSetYblDeleteBeneficiarySuccess: () => dispatch({ type: YBL_DELETE_BENEFICIARY_SUCCESS, payload: { status: false } }),
  onGetOtp: (payload) => dispatch(getOtp(payload)),
  onSetChannelFlagSuccess: () => dispatch({ type: SET_CHANNEL_FLAG_SUCCESS, payload: { status: false } }),
  onGetOtpSuccess: () => dispatch({ type: GET_OTP_SUCCESS, payload: { status: false } }),
});

const FundTransferMapStateToProps = createStructuredSelector({
  isLoadingStatus: select_isBoolean('isLoading'),
  SelectUserDetails: selectHeaderContainerJS('userDetails'),
  BeneficiariesList: select_cardBlockJS('beneficiariesList'),
  BeneficiaryUpdate: select_cardBlockJS('beneficiaryUpdate'),
  BeneficiaryCreate: select_cardBlockJS('beneficiaryCreate'),
  SetFundTransfer: select_cardBlockJS('setFundTransfer'),
  BeneficiaryView: select_cardBlockJS('beneficiaryView'),
  NsdlFundTransfer: select_cardBlockJS('nsdlfundtransfer'),
  NsdlFundTransferlist: select_cardBlockJS('nsdlfundtransferlist'),
  NsdlBeneficaryUpdate: select_cardBlockJS('nsdlBeneficiaryUpdate'),
  NsdlFundTransferView: select_cardBlockJS('nsdlfundtransferview'),
  YblVerifyLimitOtpSuccess: select_cardBlockJS('yblVerifyLimitOtpSuccess'),
  YblDeleteBeneficiarySuccess: select_cardBlockJS('yblDeleteBeneficiarySuccess'),
  GetYesBankOtpSuccess: get_yes_bank_otp('getOtpSuccess'),
  SetChannelFlagSuccess: set_channel_flag('setChannelFlagSuccess'),
});

export {
  NsdlFundTransferPropTypes,
  FundTransferPropTypes,
  FundTransferMapDispatchToProps,
  FundTransferMapStateToProps,
  OtpScreenPropTypes,
};



// WEBPACK FOOTER //
// client/containers/FundTransfer/FundTransferDatahandler.js